import { API } from "config";
import type { Task, TaskPatch } from "types/Task";
import request from "utilities/request";

const baseUrl = API.dbApi.url;

/**
 * Builds the PATCH body from only the patchable columns. The backend schema is
 * `extra="forbid"`; enumerating fields explicitly keeps a client-only field
 * (e.g. `pollExhausted`) or the claim-only `terminalDirectiveInjectedAt` from
 * ever reaching the wire. `terminalDirectiveInjectedAt` is set solely by
 * `claimTerminalTask`; it is intentionally absent from `TaskPatch` and here.
 */
function toPatchBody(patch: TaskPatch): TaskPatch {
  const body: TaskPatch = {};
  if ("status" in patch) body.status = patch.status;
  if ("statusReason" in patch) body.statusReason = patch.statusReason;
  if ("statusRaw" in patch) body.statusRaw = patch.statusRaw;
  if ("statusCachedAt" in patch) body.statusCachedAt = patch.statusCachedAt;
  if ("resultLinks" in patch) body.resultLinks = patch.resultLinks;
  if ("archiveUrl" in patch) body.archiveUrl = patch.archiveUrl;
  if ("terminalSeenAt" in patch) body.terminalSeenAt = patch.terminalSeenAt;
  if ("dismissed" in patch) body.dismissed = patch.dismissed;
  return body;
}

/** Partially updates a task row. Returns the updated row. */
export async function patchTask(
  id: string,
  patch: TaskPatch,
  getAccessToken: () => Promise<string>
): Promise<Task> {
  const accessToken = await getAccessToken();

  const url = `${baseUrl}/tasks/${id}`;
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${accessToken}`,
  };
  const options = {
    method: "PATCH",
    headers,
    body: JSON.stringify(toPatchBody(patch)),
  };

  const response = await request(url, options);
  return (await response.json()) as Task;
}
